module.exports = __webpack_public_path__ + "fonts/proximasoft-bold-webfont.6c3f094.woff2";